require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-what-documentation-will-i-need-to-open-a-business-account.json") })
        }
      }, "path---es-articles-what-documentation-will-i-need-to-open-a-business-account");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-what-documentation-will-i-need-to-open-a-business-account!./.cache/json/es-articles-what-documentation-will-i-need-to-open-a-business-account.json
// module id = 2478
// module chunks = 231608221292675